import cx from 'classnames';
import {
    BZ2_HANDMADE_PRODUCT_HOVER,
    BZ2_NEW_PRODUCT_HOVER,
    BZ2_OLD_PRODUCT_HOVER,
    BZ2_SERVICES_PRODUCT_HOVER,
} from 'mk/autogenerated/translations/QualityCheckboxes.f549bd7f316e5fe341e9167b326842e5'
import QualityCheckbox from 'mk2/apps/bazaar/components/QualityCheckbox';
import { ProductQuality } from 'mk2/apps/bazaar/schemas';
import { Quality } from 'mk2/reducers/request';
import React from 'react';
import styles from './QualityCheckboxes.mscss';

export interface OwnProps {
    className?: string;
    qualities: Quality[];
    handmadeCount: number;
    oldCount: number;
    newCount: number;
    newCountHidden?: boolean;
    servicesCount: number;
    jobsCount: number;

    onChange(key: ProductQuality, checked: boolean);
}

type Props = OwnProps;

const QualityCheckboxes: React.FunctionComponent<Props> = ({ className, handmadeCount, jobsCount, newCount, newCountHidden, oldCount, onChange, qualities, servicesCount }) => {
    return (
        <div className={cx(styles.QualityCheckboxes, className)}>
            <QualityCheckbox
                className={styles.QualityCheckboxes__quality}
                quality={ProductQuality.OLD}
                checked={qualities.includes(ProductQuality.OLD)}
                count={oldCount}
                label={BZ2_OLD_PRODUCT_HOVER}
                onChange={onChange}
            />
            <QualityCheckbox
                className={styles.QualityCheckboxes__quality}
                quality={ProductQuality.NEW}
                checked={qualities.includes(ProductQuality.NEW)}
                count={newCount}
                countHidden={newCountHidden}
                label={BZ2_NEW_PRODUCT_HOVER}
                onChange={onChange}
            />
            {!!handmadeCount && (
                <QualityCheckbox
                    className={styles.QualityCheckboxes__quality}
                    quality={ProductQuality.HANDMADE}
                    checked={qualities.includes(ProductQuality.HANDMADE)}
                    count={handmadeCount}
                    label={BZ2_HANDMADE_PRODUCT_HOVER}
                    onChange={onChange}
                />
            )}
            {!!servicesCount && (
                <QualityCheckbox
                    className={styles.QualityCheckboxes__quality}
                    quality={ProductQuality.SERVICES}
                    checked={qualities.includes(ProductQuality.SERVICES)}
                    count={servicesCount}
                    label={BZ2_SERVICES_PRODUCT_HOVER}
                    onChange={onChange}
                />
            )}

            {/* TODO consider to clean up ProductQuality.JOBS / Product.QUALITY_JOBS */}
            {/*<QualityCheckbox*/}
            {/*    className={styles.QualityCheckboxes__quality}*/}
            {/*    quality={ProductQuality.JOBS}*/}
            {/*    checked={qualities.includes(ProductQuality.JOBS)}*/}
            {/*    count={jobsCount}*/}
            {/*    label={BZ2_JOBS_PRODUCT_HOVER}*/}
            {/*    onChange={onChange}*/}
            {/*/>*/}
        </div>
    );
};

QualityCheckboxes.displayName = 'QualityCheckboxes';

export default React.memo<Props>(QualityCheckboxes);
